import TopNav, { TopNavProps } from './TopNav';
import withInteractor from './TopNav.interactor';
import withPresenter from './TopNav.presenter';
  
export type { TopNavProps };
export default withInteractor(withPresenter(TopNav));
